// @flow

/**
 * Imports
 */

// Modules
import React from 'react';
import styled from 'styled-components';

// Style
import { BLUE_GREY, COOL_GREY } from 'src/styles/palettes.js';

// Methods
import Formatter from 'src/methods/formatter';

/**
 * Styles
 */

const PrizepoolRoot = styled.div``;

const Dotation = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0.2em 0;
`;

const Background = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 8px;
  background-color: ${BLUE_GREY[900]};
  box-shadow: 0 4px 0 0 #000;
  border: 2px solid white;
  transform: skew(-6deg, 0);
`;

const Angle = styled.div`
  position: absolute;
  top: 0;
  right: -2px;
  width: 23px;
  height: 20px;
  background-color: white;
  border-radius: 0 8px 0 0;
  clip-path: polygon(100% 0%, 100% 0%, 89% 75%, 20% 0%);
`;

const Amount = styled.div`
  line-height: 1.3em;
  font-size: 2em;
  font-family: ChallLilitaOne;
  text-align: center;
  color: ${(props) => props.color};
  z-index: 1;
`;

const Label = styled.div`
  text-align: center;
  color: ${COOL_GREY[200]};
  margin-top: 6px;
`;

/**
 * Types
 */

type PropTypes = {
  className: ?string,
  amount: ?number,
  label?: string,
  currency: ?string,
  color: string
};

/**
 * Component
 */
const Prizepool = (props: PropTypes) => {
  const { className, amount, currency, label, color } = props;

  return (
    <PrizepoolRoot className={className}>
      <Dotation>
        <Background />
        <Angle />
        <Amount color={color}>{amount ? Formatter.formatNumber(amount / 100, currency) : '-'}</Amount>
      </Dotation>
      {label && <Label>{label}</Label>}
    </PrizepoolRoot>
  );
};

export default Prizepool;
